/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passkey_UnnamedInputs */

const en_passkey_unnamed = /** @type {(inputs: Passkey_UnnamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkey`)
};

const de_passkey_unnamed = /** @type {(inputs: Passkey_UnnamedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkey`)
};

/**
* | output |
* | --- |
* | "Passkey" |
*
* @param {Passkey_UnnamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const passkey_unnamed = /** @type {((inputs?: Passkey_UnnamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passkey_UnnamedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_passkey_unnamed(inputs)
	return en_passkey_unnamed(inputs)
});